/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Undertraining_OptimalInputs */

const en_coach_undertraining_optimal = /** @type {(inputs: Coach_Undertraining_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have been training hard recently, yet your acute load is still below your long-term average. This can happen after a sudden taper. Ensure the reduced load is intentional and time-limited.`)
};

const de_coach_undertraining_optimal = /** @type {(inputs: Coach_Undertraining_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast zuletzt hart trainiert, aber dein akuter Umfang liegt noch unter dem Langzeitschnitt. Passiert manchmal nach einer Taper-Phase. Stell sicher, dass der reduzierte Umfang geplant und zeitlich begrenzt ist.`)
};

/**
* | output |
* | --- |
* | "You have been training hard recently, yet your acute load is still below your long-term average. This can happen after a sudden taper. Ensure the reduced loa..." |
*
* @param {Coach_Undertraining_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_undertraining_optimal = /** @type {((inputs?: Coach_Undertraining_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Undertraining_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_undertraining_optimal(inputs)
	return de_coach_undertraining_optimal(inputs)
});